<template>
    <span v-if="session.gauge">
        il reste {{ session.gauge }} place(s)
    </span>
</template>

<script>
    export default {
        props: {
            session: Object,
        }
    }
</script>
